import {
  ApiResponse,
  CashDiscountGrouped,
  CreateDiscount,
  TokenData,
  CashDiscount,
  OtpResponse,
  CreateDiscountLimits,
  CreateCampaignDiscountGroup,
  CampaignCashDiscount,
  CampaignPoolDiscount,
  CreateCampaignPoolDiscountLimits,
  CreateCampaignPoolDiscount,
} from '../models';
import * as http from './http';
import ApiService from './service';

export class CampaignPoolDiscountService extends ApiService {
  public async loadCashDiscountType() {
    const url = `${this.apiDomain}/api/discount/cash`;

    const resposne = await http.get<ApiResponse<CashDiscountGrouped>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async createDiscount(data: CreateCampaignPoolDiscount, id?: string) {
    const url = `${this.apiDomain}/api/campaign/${id}/add-discount`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      { ...data, discountType: 'Pool_Discount' },
      this.store
    );
    return response.data;
  }

  public async updateDiscount(data: CreateCampaignPoolDiscount, id?: string) {
    const url = `${this.apiDomain}/api/campaign/${id}/update-add-discount`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      { ...data, discountType: 'Pool_Discount' },
      this.store
    );
    return response.data;
  }

  public async getPoolDiscount(id: string) {
    const url = `${this.apiDomain}/api/campaign/pool-discount/${id}`;

    const resposne = await http.get<ApiResponse<CampaignPoolDiscount>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }

  public async requestOtp(purpose?: string, requestType?: string) {
    const url = `${this.apiDomain}/api/otp/request`;

    const response = await http.post<ApiResponse<OtpResponse>>(
      url,
      {
        purpose: purpose || 'Confirm Discount Request',
        requestType,
      },
      this.store
    );
    return response.data;
  }
  public async reSendOtp(id?: string, purpose?: string, requestType?: string) {
    const url = `${this.apiDomain}/api/otp/${id}/resend`;

    const response = await http.put<ApiResponse<OtpResponse>>(
      url,
      {
        purpose: purpose || 'Confirm Discount Request',
        requestType,
      },
      this.store
    );
    return response.data;
  }

  public async updatePoolDiscountLimits(
    data?: CreateCampaignPoolDiscountLimits,
    id?: string
  ) {
    const url = `${this.apiDomain}/api/campaign/edit/${id}/pool-discount`;

    const response = await http.put<ApiResponse<OtpResponse>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async cloneDiscount(data: CreateDiscount, id?: string) {
    const url = `${this.apiDomain}/api/discount/cash/${id}/clone`;

    const response = await http.post<ApiResponse<CashDiscount>>(
      url,
      data,
      this.store
    );
    return response?.data?.data;
  }

  public async deleteDiscount(id?: string) {
    const url = `${this.apiDomain}/api/campaign/pool/${id}`;
    const response = await http.remove<ApiResponse<CampaignPoolDiscount>>(
      url,
      this.store
    );
    return response?.data?.data;
  }
}
